import apiHelper from "../../../services/apiHelper";
import CancelDetails from "../models/CancelDetails";

const CancellationService = {
  submitCancellation: (formData) => {
    return apiHelper.fetch('/membership-cancellation', {
      method: 'POST',
      body: formData
    }).then(response => {
      if (!response.ok) {
        return response.json().then(data => { return Promise.reject(data)});
      }
      return response.json();
    });
  },
  
  getCancellationStatus: () => {
    return apiHelper.fetch('/membership-cancellation/details')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to get cancellation status');
        }
        return response.json();
      }).then(data => new CancelDetails(data));
  },

  getTestCancellationStatus: (clubId, memberId) => {
    return apiHelper.fetch('/membership-cancellation/test-details?club_id=' + clubId + '&member_id=' + memberId + '&test=true')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to get cancellation status');
        }
        return response.json();
      });
  },


  freezeMembership: () => {
    return apiHelper.fetch('/membership-cancellation/freeze',
      {
        method: 'PUT',
      })
      .then(response => {
        return response.json();
      });
  },

  unfreezeMembership: () => {
    return apiHelper.fetch('/membership-cancellation/unfreeze', {
      method: 'PUT',
    })
      .then(response => {
        return response.json();
      });
  }
};

export default CancellationService;